module.exports = __webpack_public_path__ + "img/farrahicarpet-logo.5b86f46.png";